const capitalize = (name: string) => {
  return name ? (`${name}`.slice(0, 1).toUpperCase() + `${name}`.slice(1).toLowerCase()) : ''
}

export default capitalize